import React from 'react';
//import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';

import * as api from '_core/utils/api';
import { useVisitorInfo } from '_core/utils/visitorInfo';
import { withLang } from '_core/hocs/withLang';
import { useGlobal } from '_core/hooks/useGlobal';
import { useCartContext } from '_core/contexts/Cart';
import { Price } from '_core/components/Price';
import { UpwardButton } from '_core/components/UpwardButton';
import Widget from '_core/components/DeliveryWidget';


export const DeliveryWidget = withLang((props) => {
  const {
    langInfo,
    getLangString: l,
    
    ...widgetProps
  } = props;
  
  delete widgetProps.langStrings;
  delete widgetProps.getLangObject;
  delete widgetProps.getFirstLangString;
  delete widgetProps.getLangStringSet;
  
  
  const theme = useTheme();
  const {
    config: { REPLACE_CURRENCY_FROM_WAREHOUSE }
  } = useGlobal();
  
  const visitorInfo = useVisitorInfo();
  const cart = useCartContext();
  const shopCurrency = cart.shopCurrency || cart.currency;
  const deliverySessionKey = [
    shopCurrency.code || '',
    cart.warehouse?.id || 0,
    cart.getLocalityValue?.() || ''
  ].join(':');
  
  
  if (!langInfo || !visitorInfo.info?.id || cart.isLoading)
    return null;
  
  return (
    <Widget
      key={REPLACE_CURRENCY_FROM_WAREHOUSE ? deliverySessionKey : undefined}
      theme={theme.themeType}
      lang={langInfo.code}
      shop="office"
      currency={shopCurrency.code}
      cart={{
        list: cart.goods?.map((item) => ({ id: item.id, target: item.target, count: cart.getControl(item, item.target).count })),
        count: cart.query.count,
        price: cart.query.price,
        discount: cart.query.discount,
        points: cart.query.points
      }}
      group_order={{ targets: cart.groupOrderTargets?.map((target) => target.pin && visitorInfo.info?.id !== target.info.id && { id: target.info.id, code: target.pin }).filter(Boolean) }}
      warehouse={cart.warehouse && { ...cart.warehouse, title: l(cart.warehouse.title), description: l(cart.warehouse.description), address: l(cart.warehouse.address) }}
      visitor={visitorInfo.info}
      
      palette={{
        light: {
          colors: {
            basic: { value: theme.palette.background.paper, contrast: theme.variables.colors.primary },
            primary: { value: theme.variables.colors.primary, contrast: theme.palette.getContrastText(theme.variables.colors.primary) },
            secondary: { border: darken(theme.variables.colors.secondary, 0.85), value: theme.variables.colors.secondary, contrast: theme.palette.getContrastText(theme.variables.colors.secondary) },
            hover: { value: theme.palette.background.paper, contrast: theme.variables.colors.primary }
          }
        },
        
        dark: {
          button: {
            colors: {
              primary: { value: theme.palette.background.level2, contrast: theme.variables.colors.primary }
            }
          }
        }
      }}
      
      localityData={cart.localityData}
      onLocalityData={cart.setConfirmedLocalityData}
      
      priceRound={(value, currency, type = 'round') => Price.round(cart, currency || shopCurrency, value, null, false, type)}
      priceFormat={(value, currency, type = 'jsx') => Price.format(cart, currency || shopCurrency, value, null, null, null, null, type)}
      apiRequest={api.request}
      apiGetClientTokenGenerate={() => api.getClientTokenGenerate(visitorInfo.info.id)}
      apiGetClientVisitor={api.getClientVisitor}
      apiGetPortalArticle={api.getPortalArticle}
      scrollTop={() => UpwardButton.scroll.intoView()}
      
      {...widgetProps}
    />
  );
});
